firebird.factory('customChatService', [
    '$window',
    '$filter',
    'meetingService',
    'helperService',
    'localizationService',
    'logService',
    function ($window, $filter, meetingService, helperService, localizationService, logService) {
        const logger = logService.createLoggerWithSource('customChatService');

        var service = {
            generateCustomMessage: generateCustomMessage,
            validateDataObj: validateDataObj,
            isMeetingPrivateChatEnabled: isMeetingPrivateChatEnabled,
            _attachClickEvents: attachClickEvents,
            _generateRawMeetingNameAndPrivateTag: generateRawMeetingNameAndPrivateTag
        };

        return service;

        ////////////////////////

        function generateCustomMessage(data) {
            if (!service.validateDataObj(data)) {
                return;
            }

            var customMessage = generateListElement(data.msgClass);
            var outerRow = generateOuterRow();

            if (data.msgObj.notification) {
                var notificationMsg = generateNotificationMessage(data.msgObj);
                outerRow.append(notificationMsg);
            } else {
                var imgContainer = generateImgContainer(data.msgObj);
                outerRow.append(imgContainer);

                var msgContainer = generateMsgContainer(data);
                outerRow.append(msgContainer);
            }

            customMessage.append(outerRow);

            //Wrap in jQuery
            customMessage = angular.element(customMessage);

            var responseObj = {};
            if (service.isMeetingPrivateChatEnabled() && data.meetingPrivateData && data.meetingPrivateData.isSender) {
                responseObj.id = data.msgObj.respondId;
                responseObj.name = data.msgObj.respondantName;
            } else {
                responseObj.id = data.msgObj.id;
                responseObj.name = data.msgObj.name;

                responseObj.userIdentifier = data.msgObj.userIdentifier || data.msgObj.email;
            }

            service._attachClickEvents(customMessage, responseObj, data.helperFunctions);

            return customMessage;
        }

        function validateDataObj(dataObj) {
            var isMsgObjValid = false;
            var isIndexValid = false;
            var isMsgClassValid = false;

            if (dataObj) {
                if (dataObj.msgObj) {
                    isMsgObjValid = true;
                }

                if (!isNaN(dataObj.index)) {
                    isIndexValid = true;
                }

                if (dataObj.msgClass || dataObj.msgClass === '') {
                    isMsgClassValid = true;
                }
            }

            return isMsgObjValid && isIndexValid && isMsgClassValid;
        }

        function generateListElement(msgClass) {
            var rawElement = '<li class="custom message-container ' + msgClass + '"></li>';
            return angular.element(rawElement);
        }

        function generateOuterRow() {
            return angular.element('<div class="clearfix"></div>');
        }

        function generateNotificationMessage(msgObj) {
            var rawElement = [
                '<div class="col-xs-12 no padding">',
                '<span class="message">' + helperService.encodeHtml(msgObj.message) + '</span>',
                '</div>'
            ].join('');

            return angular.element(rawElement);
        }

        function generateImgContainer(msgObj) {
            var containerClasses = ['no-padding', 'img-container', 'pull-left'];
            var imgClasses = ['img-circle'];

            if (helperService.isMobile() && !helperService.isTablet()) {
                containerClasses.push('col-xs-1');
                imgClasses.push('mobile');
            } else {
                containerClasses.push('col-xs-2');
            }

            var imgElement;

            if (helperService.getIsRedesign() && helperService.isDefaultAvatarUrl(msgObj.imageURL)) {
                var colorClass = helperService.convertContactDataToColorClass(msgObj.id, msgObj.name);
                imgClasses.push('initials', colorClass);
                imgElement =
                    '<div class="' +
                    imgClasses.join(' ') +
                    '"><span>' +
                    helperService.getInitialsFromName(msgObj.name) +
                    '</span></div>';
            } else {
                imgElement =
                    '<img src="' +
                    msgObj.imageURL +
                    '" alt="image" width="32" height="32" class="' +
                    imgClasses.join(' ') +
                    '"/>';
            }

            var rawElement = ['<div class="' + containerClasses.join(' ') + '">', imgElement, '</div>'].join('');

            return angular.element(rawElement);
        }

        function generateMsgContainer(data) {
            var msgObj = data.msgObj;
            var containerClasses = ['no-padding'];

            if (helperService.isMobile() && !helperService.isTablet()) {
                containerClasses.push('col-xs-11');
            } else {
                containerClasses.push('col-xs-10');
            }

            var includeReadReceipt = helperService.getIsRedesign() && data.msgClass.indexOf('self') > -1;
            var rawElement;

            if (service.isMeetingPrivateChatEnabled()) {
                var replyBtn;
                if (data.msgClass.indexOf('self') === -1 && data.msgObj.isPrivate) {
                    replyBtn = generateReplyButton(data.msgObj.isPrivate);
                }

                rawElement = [
                    '<div class="' + containerClasses.join(' ') + '">',
                    service._generateRawMeetingNameAndPrivateTag(msgObj, data.meetingPrivateData),
                    generateRawMessage(msgObj, replyBtn),
                    generateTime(msgObj, includeReadReceipt),
                    '</div>'
                ].join('');
            } else {
                //For Webinar and for Meetings without Private Chat
                rawElement = [
                    '<div class="' + containerClasses.join(' ') + '">',
                    '<span class="name">' + $filter('linky')(msgObj.name, '_blank') + '</span>',
                    meetingService.isWebinar() ? generateRawWebinarPrivateTag(msgObj, data.webinarPrivateData) : '',
                    generateRawMessage(msgObj),
                    generateTime(msgObj, includeReadReceipt),
                    '</div>'
                ].join('');
            }

            var result = angular.element(rawElement);

            return result;
        }

        //Generates 'Private to you' label, for Webinars only
        function generateRawWebinarPrivateTag(msgObj, webinarPrivateData) {
            var privateTagClasses = ['private-tag'];
            var replyBtnClasses = ['zmdi zmdi-mail-reply'];

            if (!msgObj.isPrivate || !webinarPrivateData) {
                return '';
            }

            if (webinarPrivateData.showMsgResponse) {
                privateTagClasses.push('clickable allow-set-response');
                //Add setResponse function
            } else {
                replyBtnClasses.push('ng-hide');
            }

            var rawElement = [
                '<span class="' + privateTagClasses.join(' ') + '">',
                $filter('linky')(webinarPrivateData.privateNameDisplay, '_blank'),
                '<i class="' + replyBtnClasses.join(' ') + '"></i>',
                '</span>'
            ].join('');

            return rawElement;
        }

        //Generates '[sender full name] name to you', for Meetings with Private Chat enabled
        //If Meeting has Private Chat enabled, this gets used for private and non-private messages
        function generateRawMeetingNameAndPrivateTag(msgObj, meetingPrivateData) {
            if (!meetingPrivateData) {
                logger.warn('generateRawMeetingNameAndPrivateTag', 'no meetingPrivateData param');
                return '';
            }

            if (meetingPrivateData.isSender === undefined || !meetingPrivateData.respondantName) {
                logger.warn(
                    'generateRawMeetingNameAndPrivateTag',
                    'invalid meetingPrivateData param',
                    meetingPrivateData
                );
                return '';
            }

            //Make recipient name clickable, unless I am the recipient
            var recipientNameClasses = ['recipient-name'];
            if (!meetingPrivateData.isRecipient) {
                recipientNameClasses.push('clickable');

                if (msgObj.isPrivate) {
                    //Private message -- clicking should set private message recipient to be set to the name being clicked
                    recipientNameClasses.push('allow-set-response');
                } else {
                    //Public message -- clicking should reset private message recipient to 'everyone'
                    recipientNameClasses.push('allow-clear-response');
                }
            }

            //Make sender name clickable, unless they do not support Private Chat
            const senderNameClasses = [];
            if (!meetingPrivateData.isSender) {
                senderNameClasses.push('sender-name');
                if (meetingPrivateData.senderSupportsPrivateMeetingChat) {
                    senderNameClasses.push('clickable allow-set-response');
                }
            }

            let translatedString;
            const senderString = meetingPrivateData.isSender
                ? ''
                : `<span class="${senderNameClasses.join(' ')}">${helperService.sanitizeHtml(msgObj.name)}</span>`;
            const responderString = `<span class="${recipientNameClasses.join(' ')}">${helperService.sanitizeHtml(
                meetingPrivateData.respondantName
            )}</span>`;

            if (meetingPrivateData.isSender) {
                translatedString = localizationService.translate('SIDEBAR.PRIVATE_CHAT_TO', {
                    receipient: responderString
                });
            } else {
                translatedString = localizationService.translate('SIDEBAR.PRIVATE_CHAT_FROM_TO', {
                    sender: senderString,
                    receipient: responderString
                });
            }

            return [
                '<span class="name private-chat-enabled">',
                translatedString,
                msgObj.isPrivate
                    ? '<span class="private-label">' + localizationService.translate('COMMON.PRIVATE') + '</span>'
                    : '',
                '</span>'
            ].join('');
        }

        function generateFileUploadRawMessage(msgObj) {
            var link =
                helperService.getLocationProtocol() +
                '://www.' +
                helperService.getLocationHost() +
                '/dl/' +
                msgObj.fileDownloadContentId;
            var linkElem = $('<a target="_blank"/>')
                .text(
                    localizationService.translate('ATTENDEE_LIST.CHAT.CLICK_HERE_TO_DOWNLOAD', {
                        filename: msgObj.filename
                    })
                )
                .attr('href', link);

            var messageTxt = linkElem.wrap('<p/>').parent().html();
            if (helperService.isMobile()) {
                try {
                    messageTxt = generateMobileHyperlink(messageTxt);
                } catch (e) {
                    //Fail silently
                }
            }

            var elem = $('<span/>')
                .addClass('message')
                .addClass('on-download-click')
                .attr('data-content-id', msgObj.fileDownloadContentId)
                .append(messageTxt);
            return elem.wrap('<p/>').parent().html();
        }

        function generateRawMessage(msgObj, replyBtnObject) {
            if (msgObj.autoGenerated && msgObj.fileDownloadContentId) {
                return generateFileUploadRawMessage(msgObj, helperService);
            }

            var messageClasses = ['message'];
            var messageTxt = msgObj.message;

            if (msgObj.autoGenerated) {
                if (msgObj.fileDownloadContentId) {
                    messageClasses.push('on-download-click');
                    contentIdAttr = ' data-content-id="' + msgObj.fileDownloadContentId + '"';
                } else {
                    messageClasses.push('auto-generated');
                }
            } else {
                if (msgObj.appGenerated) {
                    messageClasses.push('app-generated');
                }

                //Linky
                messageTxt = $filter('linky')(messageTxt, '_blank');

                //Emoji
                messageTxt = $filter('emoji')(messageTxt);
            }

            if (helperService.isMobile()) {
                try {
                    messageTxt = generateMobileHyperlink(messageTxt);
                } catch (e) {
                    //Fail silently
                }
            }

            var rawElement = [
                '<span class="' + messageClasses.join(' ') + '">',
                messageTxt,
                replyBtnObject,
                '</span>'
            ].join('');

            return rawElement;
        }

        function generateReplyButton(isPrivate) {
            var messageClasses = ['reply-btn'];

            if (isPrivate) {
                messageClasses.push('private');
            } else {
                messageClasses.push('public');
            }

            return (
                '<div class="' +
                messageClasses.join(' ') +
                '"><img class="reply-icon" src="img/redesign/icons/chat-reply.svg" height="14" width="16"/></div>'
            );
        }

        function generateMobileHyperlink(messageTxt) {
            var rebuiltString = '';
            var parsedHTML = $.parseHTML(messageTxt);

            parsedHTML.forEach(function (html) {
                var wrappedElement = angular.element(html);
                var partialStr = '';

                if (wrappedElement.is('a')) {
                    var url = wrappedElement.attr('href');
                    var text = wrappedElement.html();
                    partialStr = '<a class="mobile-hyperlink" href="' + url + '">' + text + '</a>';
                } else {
                    partialStr = wrappedElement[0].data;
                }

                rebuiltString += partialStr;
            });

            return rebuiltString;
        }

        function generateTime(msgObj, includeReadReceipt) {
            var localTime = $window.moment(msgObj.time).format('LT');

            var rawElement = [
                '<span class="time-sent">',
                includeReadReceipt
                    ? '<img class="read-receipt unread" src="img/redesign/icons/sent.svg" height="11" width="11"/>'
                    : '',
                localTime,
                '</span>'
            ].join('');

            return rawElement;
        }

        function attachClickEvents(wrappedMessage, responseObj, helperFunctions) {
            wrappedMessage.find('.on-download-click a').click(function () {
                var contentId = $(this).attr('data-content-id');
                helperFunctions.onDownloadClick(contentId);
            });

            wrappedMessage.find('a.mobile-hyperlink').click(function () {
                var mobileURL = $(this).attr('href');
                if (
                    mobileURL.toLowerCase().indexOf('http://') !== 0 &&
                    mobileURL.toLowerCase().indexOf('https://') !== 0
                ) {
                    mobileURL = 'http://' + mobileURL;
                }
                meetingService.openExternalLink(mobileURL);
            });

            wrappedMessage.find('.allow-set-response').click(function () {
                helperFunctions.setResponse(responseObj);
            });

            wrappedMessage.find('.allow-clear-response').click(function () {
                helperFunctions.clearResponse();
            });

            wrappedMessage.find('.reply-btn.private').click(function () {
                helperFunctions.setResponse(responseObj);
            });

            wrappedMessage.find('.reply-btn.public').click(function () {
                helperFunctions.clearResponse();
            });
        }

        function isMeetingPrivateChatEnabled() {
            return !meetingService.isWebinar() && meetingService.getMeetingPrivateChatEnabled();
        }
    }
]);
